<template>
    <div>
      <workOrderPageAdmin v-if="!$store.getters.cusId" :closeType="true"/>
      <workOrderPageUser v-else :closeType="true"/>
    </div>
  </template>
  <script>
  import workOrderPageAdmin from './components/workOrderPageAdmin';
  import workOrderPageUser from './components/workOrderPageUser';
  export default {
    name: 'BusinessCloseWorkorderList',
    components: {
      workOrderPageAdmin,
      workOrderPageUser,
    },
  };
  </script>